import { markerColors } from '@fhs/maps/src/components/markers/marker-colors';
import {
  PIN_ART_HEIGHT,
  PIN_ART_WIDTH,
  PIN_TEARDROP_PATH,
} from '@fhs/maps/src/components/markers/store-pin-paths';

/** The house from the NOP master design file's delivery pin, scaled into the store pin's box. */
const HOUSE_PATH =
  'M11 27.8938V14.6261L20 7.9696L29 14.6261V27.8938H22.2845V20.0013H17.7155V27.8938H11Z';

/**
 * Delivery address pin: the selected-store teardrop, in the open store's red, with a house in
 * place of the badge.
 *
 * Web only. It shares the store pin's artwork box so `index.web` can anchor it on the same tip.
 */
export const deliveryAddressMarkerSvg = `
<svg width="${PIN_ART_WIDTH}" height="${PIN_ART_HEIGHT}" fill="none" viewBox="0 0 ${PIN_ART_WIDTH} ${PIN_ART_HEIGHT}" xmlns="http://www.w3.org/2000/svg">
  <path d="${PIN_TEARDROP_PATH}" fill="${markerColors.selectedOpen}" />
  <path d="${HOUSE_PATH}" fill="${markerColors.surface}" />
</svg>
`;
